import { StrictMode } from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import store from "store/store";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FirebaseProvider } from "./firebase/firebase";
import { SocketProvider } from "socket/socketProvider";

const rootElement = document.getElementById("root");
ReactDOM.render(
  <StrictMode>
    <ToastContainer />
    <FirebaseProvider>
      <SocketProvider>
        <Provider store={store}>
          <App />
        </Provider>
      </SocketProvider>
    </FirebaseProvider>
  </StrictMode>,
  rootElement
);

reportWebVitals();
